import { useCartData } from "@/zustand/cartStore";
import React, { useState } from "react";
import { useProductData } from "@/zustand/productStore";

const PurchaseTypeSelector = ({ variant = "v2", showDescription = true, onChange }) => {
  const [selected, setSelected] = useState(true);
  const isSubscribe = useCartData((state) => state.isSubscribe);
  const setIsSubscribe = useCartData((state) => state.setIsSubscribe);
  const setProductsBySubscription = useProductData((state) => state.setProductsBySubscription);
  const base = window.subscription_template;
  const prefix = variant === "v3" ? "purchaseTypeSelectorV3" : "purchaseTypeSelector";

  const v3Vars =
    variant === "v3"
      ? {
          "--pts-active-bg": base?.pts_v3_active_bg || "#FDF7F2",
          "--pts-inactive-bg": base?.pts_v3_inactive_bg || "#ffffff",
          "--pts-active-text": base?.pts_v3_active_text || "#111111",
          "--pts-inactive-text": base?.pts_v3_inactive_text || "#111111",
        }
      : undefined;

  const handleSelect = (value) => {
    setSelected(value);
    setIsSubscribe(value);
    setProductsBySubscription(value);
    if (onChange) onChange(value);
  };

  return (
    <div className={`${prefix}__wrapper`} style={v3Vars}>
      <div className={`${prefix}__container`}>
        <div
          className={`${prefix}__option ${selected ? `${prefix}__selected` : ""}`}
          onClick={() => handleSelect(true)}
          role="button"
          tabIndex={0}
          aria-pressed={selected}
        >
          {base?.tr_subscribe_and_save}
        </div>
        <div
          className={`${prefix}__option ${!selected ? `${prefix}__selected` : ""}`}
          onClick={() => handleSelect(false)}
          role="button"
          tabIndex={0}
          aria-pressed={!selected}
        >
          {base?.tr_one_time_purchase}
        </div>
      </div>
      {showDescription && (
        <div className={`${prefix}__description`}>
          {isSubscribe ? base?.tr_subscription_description : base?.tr_onetime_description}
        </div>
      )}
    </div>
  );
};

export default PurchaseTypeSelector;
